import CTable from './CTable'
export default CTable;